import React from "react";
import styles from "./registerevent.module.css";

//영수증 크게 보기 오버레이 (카톡 등 인앱 브라우저에서 "길게 눌러 이미지 저장" 유도용)
//등록인증 이벤트 페이지(registerevent)와 결제선생 영수증 페이지(paymentreceipt)에서 공용

interface ReceiptViewerProps {
    open: boolean;
    imgSrc: string;
    onClose: () => void;
}

const ReceiptViewer: React.FC<ReceiptViewerProps> = ({ open, imgSrc, onClose }) => {

    if (!open || !imgSrc) {
        return null;
    }

    return (
        <div className={styles.viewer}>
            <p className={styles.viewerGuide}>영수증 이미지를 <b>길게 눌러</b><br />‘이미지 저장(사진에 저장)’을 선택해 주세요</p>
            <div className={styles.viewerImgWrap}>
                <img src={imgSrc} alt="결제 영수증" className={styles.viewerImg} />
            </div>
            <button type="button" className={styles.viewerClose} onClick={onClose}>닫기</button>
        </div>
    );
};

//클라이언트가 그린 영수증 PNG를 서버에 올려 https 이미지 URL로 만들기
//(인앱 브라우저 길게 눌러 저장은 https 이미지에서 확실하게 동작. 실패하면 null - dataURL로 폴백)
export const uploadReceiptImage = async (billId: string, code: string, blob: Blob): Promise<string | null> => {
    try {
        const formData = new FormData();
        formData.append("bill_id", billId);
        formData.append("code", code);
        formData.append("image", new File([blob], "receipt.png", { type: "image/png" }));

        const response = await fetch("https://peetsunbae.com/api/payments/reviewevent/receiptimage", {
            method: "post",
            body: formData
        });

        const result = await response.json();

        if (result.message === "success" && result.data && result.data.url) {
            return "https://peetsunbae.com" + result.data.url;
        }

        return null;
    } catch (e) {
        console.log(e);
        return null;
    }
};

export default ReceiptViewer;
